import MountainsIcon from '@repo/ui/src/components/Icons/MountainsIcon';
import { classNames } from '@repo/ui/src/utils/classNames';
import React from 'react';

interface LoadingLogoProps {
  className?: string;
  svgClassName?: string;
  small?: boolean;
  xSmall?: boolean;
}
const LoadingLogo = ({ className, svgClassName, small }: LoadingLogoProps) => (
  <span
    data-testid="loading-logo"
    className={classNames(
      'tw-grid tw-place-content-center tw-h-full tw-text-surface-200',
      className,
    )}
  >
    <MountainsIcon
      className={classNames(svgClassName, small ? 'tw-h-7' : 'tw-max-w-lg tw-w-full')}
      disableSize
      shimmer={{
        id: 'shimmer',
        highlightColor: 'var(--tra-color-surface-300)',
      }}
    />
  </span>
);

export default LoadingLogo;
